export default class Translations {
    public searchButtonText: string;
    public searchPlaceholder: string;
    public page: PageTranslations;
    public result: ResultTranslations;

    constructor(init?: Partial<Translations>){
        Object.assign(this, init);
    }
}

export class PageTranslations {
    public of: string;
    public previous: string;
    public next: string;
}

export class ResultTranslations {
    public noResultsSentence: string;
    public singleResultSentence: string;
    public multipleResultsSentence: string;
    public singleResultText: string;
    public multipleResultsText: string;
}